import { FiCheck, FiArrowRight } from "react-icons/fi";
import { useAppContext } from "../context/AppContext";

const ServicePackages = ({ packages = [] }) => {
  const { social } = useAppContext();

  if (!packages || packages.length === 0) {
    return null;
  }

  const whatsapp = social?.find(
    (item) => item.name?.toLowerCase() === "whatsapp"
  );

  const getWhatsappUrl = () => {
    if (!whatsapp?.url) {
      return "#contact";
    }

    const productPath = window.location.pathname;

    const separator = whatsapp.url.includes("?") ? "&" : "?";

    return `${whatsapp.url}${separator}product_path=${encodeURIComponent(
      productPath
    )}`;
  };

  return (
    <section>
      <div className="container mx-auto px-4 mt-12 mb-12">

        {/* Header */}
        <div className="text-center mb-12 md:mb-14">
          <span className="inline-block text-sm md:text-base font-semibold tracking-[0.25em] text-[#1E3A5F] uppercase mb-4">
            Paket Layanan
          </span>

          <h2 className="text-3xl md:text-4xl font-bold text-[#1F2937]">
            Paket Event Organizer
          </h2>

          <p className="mt-3 text-[#6B7280] text-base md:text-lg">
            Pilihan paket yang dapat disesuaikan dengan kebutuhan event Anda
          </p>
        </div>

        {/* Packages */}
        <div
          className={`grid gap-6 ${
            packages.length === 1
              ? "max-w-md mx-auto"
              : packages.length === 2
              ? "md:grid-cols-2 max-w-4xl mx-auto"
              : "md:grid-cols-2 lg:grid-cols-3"
          }`}
        >
          {packages.map((pkg, index) => (
            <div
              key={pkg.id || index}
              className="group flex flex-col bg-white border border-[#E5E7EB] rounded-2xl overflow-hidden shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
            >
              {/* Package Header */}
              <div className="bg-[#1E3A5F] px-6 py-5">
                <h3 className="text-xl font-semibold text-white text-center">
                  {pkg.name}
                </h3>
              </div>

              {/* Content */}
              <div className="flex flex-col flex-1 px-6 py-7">

                {/* Price */}
                {(pkg.promo_label || pkg.price) && (
                  <div className="text-center mb-7">
                    {pkg.promo_label && (
                      <span className="text-sm text-[#9CA3AF] mr-1">
                        {pkg.promo_label}
                      </span>
                    )}

                    {pkg.price && (
                      <span className="text-xl md:text-2xl font-bold text-[#1E3A5F]">
                        {pkg.price}
                      </span>
                    )}
                  </div>
                )}

                {/* Description */}
                {pkg.description && (
                  <p className="text-sm text-[#6B7280] leading-6 text-center mb-6">
                    {pkg.description}
                  </p>
                )}

                {/* Features */}
                {pkg.items?.length > 0 && (
                  <div className="space-y-3 flex-1">
                    {pkg.items.map((item, itemIndex) => (
                      <div
                        key={item.id || itemIndex}
                        className="flex items-start gap-3"
                      >
                        <span className="flex-shrink-0 w-5 h-5 rounded-full bg-[#EEF3F8] text-[#1E3A5F] flex items-center justify-center mt-0.5">
                          <FiCheck size={13} strokeWidth={2.5} />
                        </span>

                        <span className="text-sm text-[#4B5563] leading-6">
                          {item.name}
                        </span>
                      </div>
                    ))}
                  </div>
                )}

                {/* CTA */}
                <a
                  id="btn-wa"
                  href={getWhatsappUrl()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-8 w-full flex items-center justify-center gap-2 px-5 py-3 rounded-xl border border-[#1E3A5F] text-[#1E3A5F] font-semibold text-sm hover:bg-[#1E3A5F] hover:text-white transition-all duration-300"
                >
                  Tanya Lebih Lanjut
                  <FiArrowRight size={16} />
                </a>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ServicePackages;